import * as actionTypes from './actionTypes'
import { fromJS } from 'immutable'

const defaultState = fromJS({
    msg: 'this.is.home.redux.store.msg',
    selectedTab:'home'  , //hedui 核对， tzs 通知书 ， serch 查询
})



export default (state = defaultState, action) => {

    // console.log('home--store--->',state.get('homeData'))

    switch (action.type) {
        case actionTypes.SET_MAIN_TABBAR_DATA:
            return state.set('selectedTab',action.data)

        default:
            return state;
    }
}
